module.exports = __webpack_public_path__ + "static/media/09-07.d0044612.png";